(() => {
  const userActivityEvents = [
    'mousedown',
    'mousemove',
    'keydown',
    'scroll',
    'touchstart',
    'keypress',
    'touchmove',
  ];
  const SCRIPTS_LOADED_FLAG = 'third-party-scripts-loaded';
  const SCRIPT_LOAD_TIMEOUT = 5000;
  let isLoadingStarted = false;

  async function onUserActivity() {
    if (isLoadingStarted) return;
    isLoadingStarted = true;

    for (const event of userActivityEvents) {
      window.removeEventListener(event, onUserActivity);
    }

    window.dispatchEvent(new CustomEvent('third-party-scripts-loading'));

    const scriptTagsForLoad = Array.from(
      document.querySelectorAll('script[data-lazy-src]')
    );

    const scriptsLoad = [];

    for (const scriptTag of scriptTagsForLoad) {
      const scriptSrc = scriptTag.dataset.lazySrc;

      const scriptLoad = new Promise((resolve) => {
        const timeoutId = window.setTimeout(() => {
          resolve();
        }, SCRIPT_LOAD_TIMEOUT);

        scriptTag.onload = () => {
          window.clearTimeout(timeoutId);
          resolve();
        };
        scriptTag.onerror = () => {
          window.clearTimeout(timeoutId);
          resolve();
        };
      });

      scriptsLoad.push(scriptLoad);
      scriptTag.src = scriptSrc;
      scriptTag.removeAttribute('data-lazy-src');
    }

    window.dispatchEvent(new CustomEvent('load-head-scripts'));

    await Promise.all(scriptsLoad);

    localStorage.setItem(SCRIPTS_LOADED_FLAG, 'true');

    window.dispatchEvent(new CustomEvent('third-party-scripts-loaded'));

    document.documentElement.classList.add('third-party-scripts-loaded');
  }

  function startListenUserActivity() {
    for (const event of userActivityEvents) {
      window.addEventListener(event, onUserActivity);
    }
  }

  window.addEventListener('load', () => {
    if (localStorage.getItem(SCRIPTS_LOADED_FLAG)) {
      onUserActivity();
    } else {
      startListenUserActivity();
    }
  });
})();
